<template>
  <el-form :model="form" ref="form" class="form-warp">
    <el-table :data="form.tableData" stripe>
      <el-table-column type="index" width="55" align="center"></el-table-column>
      <template v-for="col in tableCols">
        <el-table-column :key="col.prop" :prop="col.prop" align="center">
          <template slot="header" slot-scope="scope">
            <span v-if="col.required" style="color: red">*</span>
            {{ col.label }}
            <el-button v-if="col.isBatch" type="text" @click="batchSet(col)">批量设置</el-button>
          </template>
          <template slot-scope="{ row, $index }">
            <template v-if="col.prop === 'volume'"> {{ getVolumeValue(row) }} </template>
            <template v-else-if="col.input">
              <el-form-item :prop="`tableData[${$index}].${col.prop}`" :rules="rules[col.prop]">
                <el-input-digit
                  v-if="col.input.type === 'number'"
                  v-model.number="row[col.prop]"
                  :nullable="true"
                  v-bind="col.input.attrs"
                  @change="changHandle(col)"
                />
                <el-input v-else-if="col.input.type === 'text'" v-model="row[col.prop]" v-bind="col.input.attrs"> </el-input>
                <span v-else>{{ row[col.prop] }}</span>
              </el-form-item>
            </template>
            <span v-else>{{ row[col.prop] }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-dialog title="批量设置" :visible.sync="dialogBatchVisible">
      <el-form label-width="100px">
        <el-form-item :label="`${batchCol.label}：`">
          <el-input-digit v-model.number="batchVal" :nullable="true" v-bind="batchCol.input.attrs" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBatchVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchDialiogSure">确 定</el-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props'],
  inject: ['alibabaFormVm'],
  data() {
    return {
      form: {
        tableData: [],
      },
      rules: {
        weight: [{ required: true, message: '重量不能为空' }],
      },
      tableCols: [],
      dialogBatchVisible: false,
      batchVal: '',
      batchCol: {
        input: {}
      },
    };
  },
  computed: {},
  watch: {
    alibabaSpecifications: {
      handler() {
        this.getCols();
        this.updateTableData(true);
      },
      deep: true,
    },
    'alibabaForm.showLogisticsCategory'() {
      this.form.tableData = [];
      this.$nextTick(() => {
        this.getCols();
        this.updateTableData();
      });
    },
    'alibabaForm.salePropTableXhList'(v) {
      if (v?.length) {
        this.getCols();
        this.updateTableData(true);
      }
    },
  },
  methods: {
    getCols() {
      let cols = [];
      if (this.alibabaForm.showLogisticsCategory === 'sku') {
        if (this.alibabaForm.salePropTableXhList?.length) {
          cols.push({
            prop: '规格型号',
            label: '规格型号',
          });
        } else {
          this.alibabaSpecifications.filter(Boolean).map((item, index) => {
            if (!!(item.checked || item.checked === undefined)) {
              cols.push({
                prop: item.name,
                label: item.name,
                isSpec: true,
              });
            }
          });
        }
      }
      cols = cols.concat([
        { prop: 'length', label: '长(cm)', isBatch: true, input: { type: 'number', attrs: { max: 10000 } } },
        { prop: 'width', label: '宽(cm)', isBatch: true, input: { type: 'number', attrs: { max: 10000 } } },
        { prop: 'height', label: '高(cm)', isBatch: true, input: { type: 'number', attrs: { max: 10000 } } },
        { prop: 'volume', label: '体积(cm³)' },
        { prop: 'weight', label: '重量(g)', isBatch: true, input: { type: 'number', attrs: { precision: 0} }, required: true },
      ]);
      this.tableCols = cols;
    },

    updateTableData(oldValues) {
      let list = [];
      if (this.alibabaForm.showLogisticsCategory === 'sku') {
        if (this.alibabaForm.salePropTableXhList?.length) {
          this.alibabaForm.salePropTableXhList.map(xh => {
            let item = { ['规格型号']: xh };
            const oldItem = this.form.tableData.find(v => v['规格型号'] === xh);
            const oriSkuFindItem =
              this.alibabaData.skuList.find(sku => {
                const findIndustry = (sku.industrySkuSpecifications || []).find(industry => industry.name === '规格型号') || {};
                return findIndustry.value === xh;
              }) || {};
            this.tableCols.forEach(col => {
              if (col.label !== '规格型号') {
                item[col.prop] = oriSkuFindItem[col.prop] || '';
                if (oldItem) {
                  item[col.prop] = oldItem[col.prop] || '';
                }
              }
            });
            list.push(item);
          });
        } else {
          this.alibabaSkuList.map(sku => {
            let item = { _skuid: sku._skuid };
            this.tableCols.forEach(col => {
              if (col.isSpec) {
                const findItem = sku.skuSpecifications.find(skuSpec => skuSpec.name === col.prop) || {};
                item[col.prop] = findItem.value;
              } else {
                item[col.prop] = sku[col.prop] || '';
              }
            });
            if (oldValues) {
              const oldItem = this.form.tableData.find(v => v._skuid === sku._skuid);
              if (oldItem) {
                item = {
                  ...item,
                  length: oldItem.length || '',
                  width: oldItem.width || '',
                  height: oldItem.height || '',
                  volume: oldItem.volume || '',
                  weight: oldItem.weight || '',
                };
              }
            }
            list.push(item);
          });
        }
      } else {
        let item = { length: '', width: '', height: '', volume: '', weight: '', ...this.alibabaForm.itemOfficialLogistics };
        if (oldValues) {
          item = { ...item, ...this.form.tableData[0] };
        }
        list.push(item);
      }
      this.form.tableData = list;
      this.validateTable();
    },
    changHandle(col) {
      if (col.prop === 'weight') {
        this.validateTable();
      }
    },
    validateTable() {
      this.$nextTick(() => {
        this.$refs.form.validate(valid => {
          setTimeout(() => {
            this.alibabaFormVm?.getErrorCount();
          }, 500);
        });
      })
    },
    getVolumeValue(row) {
      const { length, width, height } = row || {};
      let volume = 0;
      if (length > 0 && width > 0 && height > 0) {
        volume = (length * width * height).toFixed(3);
      }
      return volume * 1;
    },
    batchSet(col) {
      this.dialogBatchVisible = true;
      this.batchCol = col;
      this.batchVal = '';
    },
    batchDialiogSure() {
      this.form.tableData.forEach(row => {
        row[this.batchCol.prop] = this.batchVal;
      });
      this.dialogBatchVisible = false;
      if (this.batchCol.prop === 'weight') {
        this.validateTable();
      }
    },
    method_getData() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            const list = this.form.tableData.map(row => {
              return {
                ...row,
                volume: this.getVolumeValue(row),
              };
            });
            resolve(list);
          } else {
            // 验证不通过的逻辑
            console.log('验证不通过，请检查输入');
            resolve(false);
            return false;
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
  
<style lang="scss" scoped>
.form-warp {
  ::v-deep .el-form-item__error {
    position: unset;
  }
}
</style>